import { SetListenerIfc } from 'projects/game-utils/src/lib/event-source/set/SetListenerIfc';
import { RankingItem } from './RankingItem';
import { RecShapeIfc } from 'projects/game-utils/src/lib/event-source/shape/RecShapeIfc';
import { RankingStats } from 'projects/game-utils/src/lib/event-source/utils/RankingStats';
import { ApplicationControllerService } from '../service/application-controller.service';
import { BitBoardEntity } from 'projects/game-utils/src/lib/event-source/utils/BitBoardEntity';
import { AbstractGs } from 'projects/game-utils/src/lib/service/AbstractGs';
import { AbstractImageService } from 'projects/game-utils/src/lib/service/abstract.image.service';

export class WeeklyEventToRankingItem implements SetListenerIfc{
    batchChange:Array<RankingItem>;
    
    beCount:number = 0;
    
    idToPosition:Map<number, number>
    
    isSetListener():boolean{
        return true;
    }
    
    constructor(
        private name:String,
        private gameService:AbstractGs,
        private shape:RecShapeIfc, private rankingStats:RankingStats, 
        private imageService:AbstractImageService, private controller:ApplicationControllerService)
    {
        this.idToPosition = new Map<number, number>();
    }
    
    public flushChanges():void
    {
        for (let item of this.batchChange)
        {
            this.rankingStats.set(item.getPositionInViewport(), item);
            //this.rankingStats.dataProvider[item.getPositionInViewport()] = item;
        }
    }
    
    public begin():void
    {
        if (this.beCount++ == 0)
        {
            this.batchChange = new Array<RankingItem>();
        }
    }
    
    public end():void
    {
        if (--this.beCount == 0)
        {
            this.flushChanges();
            this.batchChange = new Array<RankingItem>();
        }
    }
    
    public reset():void
    {
        this.rankingStats.clearData();
        //dataProvider = [];
        this.batchChange = new Array<RankingItem>();
        this.idToPosition = new Map<number, number>();
        
        //initialize with empty slots
        for (let i:number = 0; i < this.rankingStats.windowSize; i++)
        {	
            this.rankingStats.pushData( this.imageService.generateEmptySlot());			
            //this.rankingStats.dataProvider.push( this.imageService.generateEmptySlot());
        }
    }
    
    public addRecord(id:number):void
    {
        let playerId:string = this.shape.getStringByName(id, "PlayerId");
        let playerName:string = this.shape.getStringByName(id, "PlayerName");
        let playerImg:string = this.shape.getStringByName(id, "PlayerImg");
        let loggedId:boolean = this.shape.getBooleanByName(id, "LoggedId");
        let wins:number = this.shape.getNumberByName(id, "Wins");
        let losts:number = this.shape.getNumberByName(id, "Losts");
        let scores:number = this.shape.getNumberByName(id, "Scores");
        let position:number = this.shape.getNumberByName(id, "position");
        let viewportPosition:number = this.shape.getIntByName(id, "viewportPosition");

        this.idToPosition[id] = viewportPosition;
        
        var newRanking:RankingItem = new RankingItem(playerId, playerName, playerImg, scores, loggedId, true, position, viewportPosition);
        newRanking.setBackgroundImg(this.imageService.getPlayerSlot(playerId == this.gameService.user.getCurrentUser()));
        this.batchChange.push(newRanking);
    }
    
    public addRecords(ids:Array<number>):void
    {
        for (let id of ids)
        {
            this.addRecord(id);
        }
    }
    
    public deleteRecord(id:number):void
    {
        var position:number = this.idToPosition[id];			
        //this.rankingStats.dataProvider[position] = this.imageService.generateEmptySlot();
        this.rankingStats.set(position, this.imageService.generateEmptySlot());
        delete this.idToPosition[id];
        //this.idToPosition[id] = -1;
    
    }
    
    public deleteRecords(ids:Array<number>):void
    {
        for (let id of ids)
        {
            this.deleteRecord(id);
        }
    }
    
    public cellsUpdated(colls:BitBoardEntity, id:number):void
    {
        let playerId:string = this.shape.getStringByName(id, "PlayerId");
        let playerName:string = this.shape.getStringByName(id, "PlayerName");
        let playerImg:string = this.shape.getStringByName(id, "PlayerImg");
        let loggedId:boolean = this.shape.getBooleanByName(id, "LoggedId");
        let wins:number = this.shape.getNumberByName(id, "Wins");
        let losts:number = this.shape.getNumberByName(id, "Losts");
        let scores:number = this.shape.getNumberByName(id, "Scores");
        let position:number = this.shape.getNumberByName(id, "position");
        let viewportPosition:number = this.shape.getIntByName(id, "viewportPosition");
        
        let oldPosition:number = this.idToPosition[id];
        this.rankingStats.set(oldPosition, this.imageService.generateEmptySlot());
        //this.rankingStats.dataProvider[oldPosition] = this.imageService.generateEmptySlot();
        
        this.idToPosition[id] = viewportPosition;
        
        let newRanking:RankingItem = new RankingItem(playerId, playerName, playerImg, scores, loggedId, true, position, viewportPosition);
        newRanking.setBackgroundImg(this.imageService.getPlayerSlot(playerId == this.gameService.user.getCurrentUser()));
        
        this.batchChange.push(newRanking);
    }
    
    public setContainerMetaData(name:string, value:string):void
    {
        this.rankingStats.addMeta(name, value);
    }
    
    public setContainerMetaDatas(names:Array<string>, values:Array<string>):void
    {
        this.rankingStats.addMetas(names, values);
    }
    
    public removeContainerMetaDatas(names:Array<string>):void
    {
        this.rankingStats.removeMetas(names);
    }
    
    public removeMetaData(name:string):void
    {
        this.rankingStats.removeMeta(name);
    }
}